<script lang="ts">
    import { page as currentPage } from '$app/state';
	// import Toast from '$lib/components/Toast.svelte';
    // import { toastStore } from '$lib/stores/toasts';

    let { children, data } = $props();

    let pages = [
        // { path: '/admin/home', name: 'Home' },
        // { path: '/admin/aktualnosci', name: 'Aktualności' },
        // { path: '/admin/kadra', name: 'Kadra' }
    ]

    async function logout() {
        await fetch('/admin/login', {
            method: 'DELETE'
        });

        // as I have problem with invalidate all and redirect loop 
        // I couldn't logout properly so I have to reload the page
        window.location.reload();
    }

    // let toasts = $state<any[]>([]); 
    // toastStore.subscribe((val) => {
    //     toasts = val;
    // })
</script>

<header class="header container">

    {#if data.user}
    <span>Witaj {data.user.username}</span>
    <nav class="nav">
        {#each pages as page}
            <a 
                href={page.path}
                class="nav-item"
                aria-current={currentPage.url.pathname === page.path ? 'page' : undefined}
            >
                {page.name}
            </a>
        {/each}
    </nav>

    <div>
        <button 
            class="btn btn--light"
            onclick={logout}
        >
            Wyloguj
        </button>
    </div>
    {/if}
</header>

<main class="container admin-main">
	{@render children()}
</main>

<!-- <div class="toast-list">
    {#each toasts as toast}
        <Toast type={toast.type}>{toast.message}</Toast>
    {/each}
</div> -->

<style>
    .admin-main {
        padding: 4rem 0;
    }

    .header {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        margin-top: 1rem;
        /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06); */
    }

    .nav {
        display: flex;
        gap: 1rem;
    }

    .nav-item {
        text-decoration: none;
        color: var(--color-text);
        transition: all 0.2s ease-in-out;
    }

    .nav-item:hover {
        color: var(--color-theme-1);
    }

    .nav-item[aria-current="page"] {
        border-bottom: 1px solid var(--color-theme-1);
    }

    .toast-list {
        position: fixed;
        top: 1rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        z-index: 9999;
    }
</style>